module.exports = __webpack_public_path__ + "static/brixbrine_white-2fec167731c263ad08efa952368419a5.png";